import { render, staticRenderFns } from "./ConsignmentModal.vue?vue&type=template&id=5de561b6&"
import script from "./ConsignmentModal.vue?vue&type=script&lang=js&"
export * from "./ConsignmentModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports